const styles = `:host {
  /* Using !important here is necessary. The most common reason is for MUI to add
    * { box-sizing: content-box; }
    and that will override any
    :host { box-sizing: border-box }
    in our code
  */
  box-sizing: border-box !important;
  display: flex;
  flex-direction: row;
}
:host ::slotted(chameleon-avatar),
:host chameleon-avatar {
  border: 2px solid var(--goto-text-04);
  border-radius: 50%;
  margin: 0 0 0 -10px;
  position: relative;
}
:host ::slotted(chameleon-avatar):first-of-type,
:host chameleon-avatar:first-of-type {
  margin-left: -10px;
}`; export default styles;